var MDB = window.MDB || {};;

(function($) {
    $.extend(MDB, {
        initDivisionGrid: function(table, divisionId, enableEditing, usersTable) {
            var builder = MDB.KendoConfigBuilder;
            var crudBaseUrl = '/api/Division/';
            var autocompleteUrl = crudBaseUrl + 'Suggestions';
            var createLinkHref = table.data('create-url');
            var editLinkHref = table.data('edit-url');
            var openLinkHref = table.data('open-url');

            var returnUrl = table.data('return-url');
            var dateFormat = 'dd-MM-yyyy HH:mm';
            var addDivisionTemplate = undefined;
            
            var lastSelection;
            var selectedRowId;
            

            if (enableEditing){
                addDivisionTemplate = builder.gridToolbarCustomCommandTemplate(
                    'create-custom',
                    createLinkHref,
                    { id: 'parentId' },
                    { returnUrl: returnUrl },
                    'Area_Index_Create_Button',
                    'k-add',
                    'Type'
                );
            }

            var gridConfig = createGridConfig({
                transport: {
                    read: builder.dataSourceHybridClientServerRead(table,
                        {
                            url: crudBaseUrl,
                            data: { membersToExpand: enableEditing ? [ 'UserCount' ] : [] }
                        }),
                    parameterMap: function(data) {
                        return MDB.changeKey(data, 'id', 'divisionId');
                    }
                },
                schema: createSchema(),
                sort: {
                    field: 'Name',
                    dir: 'asc'
                },
                requestEnd: builder.dataSourceOffsetUTFDatesToLocalTime()
            });

            var grid = table.kendoTreeList(gridConfig).data('kendoTreeList');

            if (enableEditing) {  
                grid.content.on('click', 'tr', function(e) {
                    var target = $(e.target);
                    
                    if (!target.is('.k-button, .k-icon:not(.k-i-none)')) {
                        var row = target.closest('tr');
                        var dataItem = grid.dataItem(row);
                        var currentSelection = dataItem.uid;

                        grid.items().filter('[data-uid!="' + currentSelection + '"]').removeClass('k-state-selected');
                        row.addClass('k-state-selected');
                        selectedRowId = row.data('uid');

                        if (currentSelection !== lastSelection && addDivisionTemplate) {
                            // Make sure the create button adds divisions as children of the currently selected one.
                            table.find('.k-grid-toolbar').html(kendo.template(addDivisionTemplate)(dataItem));

                            if (usersTable) {
                                var usersGrid = usersTable.data('kendoGrid');
                                if (usersGrid) {
                                    usersGrid.destroy();
                                    usersTable.empty();
                                }

                                MDB.initUsersGrid(usersTable, dataItem.Id, true, false);
                            }                           
                        }

                        if (target.is('.chkbx-disable-division')){
                            setEnabledStatus(target, dataItem.Id);
                        }

                        lastSelection = currentSelection;
                    }
                });

                // Restores the correct visual indicator for the selected row after sorting/filtering.
                new MutationObserver(function (mutationsList) {
                    if (selectedRowId) {                    
                        table.find('tr[data-uid!="' + selectedRowId + '"].k-state-selected')
                            .removeClass('k-state-selected')
                            .end()
                            .find('tr[data-uid="' + selectedRowId + '"]:not(.k-state-selected)')
                            .addClass('k-state-selected');
                    }

                })
                    .observe(table.find('tbody').get(0),
                        {
                            subtree: true,
                            childList: true,
                            attributes: true,
                            attributeFilter: ['data-uid']
                        });
            }

            grid.one('dataBound', function (e) {
                table.find('tbody > tr:eq(0)').find('[data-command="delete-custom"], [data-command="open"]').remove();

                if (usersTable) {
                    grid.content.find('tr').first().click();
                }
            });

            grid.dataSource.read({ firstRequest: true, maxResults: 100, divisionId: divisionId });

            function setEnabledStatus(target, divisionId) {
                var enabled = target.prop('checked');
                
                var data = {
                    id: divisionId,
                    isEnabled: enabled
                };
                
                $.ajax({
                    url: sprintf('%s?%s', crudBaseUrl, $.param(data)),
                    method: 'PUT',
                    contentType: 'application/json',
                    error: function (data) {
                        target.prop('checked', !enabled);
                        if (data.responseJSON) {
                            MDB.alert(data.responseJSON.Message);
                        }
                    }
                })
            }
            
            function createSchema() {
                return {
                    model: {
                        id: 'Id',
                        fields: {
                            parentId: {field: 'ParentId', nullable: true},
                            hasChildren: {field: 'HasActiveChildren'},
                            Modified: {type: 'date'},
                            UserCount: {type: 'number'},
                            IsEnabled: {type: 'boolean'}
                        }
                    },
                    data: 'Data',
                    total: 'Total'
                };
            }

            function createGridConfig(dataSource) {
                var config = {
                    autoBind: false,
                    dataSource: dataSource,
                    dataBound: function(e) {
                        if (selectedRowId) {
                            $('tr[data-uid="' + selectedRowId + '"]').addClass('k-state-selected');
                        }
                    },
                    columnMenu: true,
                    columns: [
                        {
                            field: 'Name',
                            title: MDB.loadResourceString('Area_Index_Divisions_Name_Header'),
                            filterable: builder.gridStringFilter(autocompleteUrl, 'Name', 500)
                        },
                        {
                            field: 'Description',
                            title: MDB.loadResourceString('Area_Index_Divisions_Description_Header'),
                            template: function (item) {
                                return !!item.Description ? item.Description : '' 
                            }
                        },
                        {
                            field: 'Modified',
                            title: MDB.loadResourceString('Area_Index_Divisions_Modified_Header'),
                            format: sprintf('{0:%s}', dateFormat),
                            filterable: builder.gridDateTimeFilter()
                        }
                    ],
                    filterable: builder.gridGlobalFilterableSettings(),
                    sortable: true,
                    resizable: true,
                    reorderable: true,
                    messages: {
                        commands: builder.commandLabels(),
                        noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
                    }
                };

                if (enableEditing) {
                    config.toolbar = kendo.template(addDivisionTemplate)({ id: divisionId });

                    config.columns.push({
                        field: 'UserCount',
                        title: MDB.loadResourceString('Area_Index_Divisions_UserCount_Header'),
                        filterable: true
                    }, {
                        field: 'IsEnabled',
                        title: 'Enabled',
                        template: builder.gridCheckboxTemplate('IsEnabled', 'chkbx-disable-division', false, divisionId),
                        filterable: builder.boolDropdownFilter()
                    });
                }

                var commands = [];
                if (enableEditing) {
                    commands.push(builder.gridCustomLinkCommand('edit-custom', editLinkHref, ['Id'], { returnUrl: returnUrl }));
                    commands.push(builder.gridCustomDeleteCommand('Delete Area', createPromptText, crudBaseUrl));
                } else {
                    if (openLinkHref) {
                        commands.push(builder.gridCustomLinkCommand('open', openLinkHref + '/Index',
                            ['Id'], {}, 'Area_Index_Index_Tooltip', 'k-i-search'));
                    }
                }

                if (commands.length > 0) {
                    config.columns.push(builder.gridCommandColumn(commands, commands.length === 1 ? 150 : 300));
                }

                return config;
            }

            function createPromptText(item) {
                var name = item.Name;

                return !item.hasChildren ?
                    sprintf(MDB.loadResourceString('Area_Index_Delete_Warning_Format1'), name) :
                    sprintf(MDB.loadResourceString('Area_Index_Delete_Warning_Format2'), name);
            }
        }
    });
})(jQuery);